/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import qs from 'query-string';

const queryString = (query) =>
	typeof query === 'string'
		? query
		: [
				'',
				Object.entries(query)
					.map((pair) => pair.map(encodeURIComponent).join('='))
					.join('&')
		  ].join('?');

const preserveScope = (url) => {
	const { scope } = qs.parse(window.location.hash);
	const scopeString = qs.stringify({ scope });
	return url.indexOf('#') === -1 ? [url, scopeString].join('#') : [url, scopeString].join('&');
};

export const Path = {
	app: (id, query = '') => preserveScope(`/apps/${id}${queryString(query)}`),
	dashboard: () => preserveScope(`/dashboard`),
	administration: () => preserveScope(`/administration`),
	user: (id) => preserveScope(`/users/${id}`),
	users: () => preserveScope(`/users`),
	workspaces: () => preserveScope(`/workspaces`),
	workspace: (id) => preserveScope(`/workspaces/${id}`),
	accounts: () => preserveScope(`/accounts`),
	account: (id) => preserveScope(`/accounts/${id}`),
	integrations: () => preserveScope(`/integrations`),
	integration: (id) => preserveScope(`/integrations/${id}`),
	database: () => preserveScope(`/database`),
	license: () => preserveScope(`/license`),
	export: (machineId) => preserveScope(['/export', machineId ? `app=${machineId}` : ''].filter((e) => !!e).join('?'))
};
